module.exports = __webpack_public_path__ + "img/TC70.51d910ff.png";